export const isNaNOrInfinity = (n: number) =>
  Number.isNaN(n) || !Number.isFinite(n)
